export const courseTypes = {
  ePub: "ePub",
  bronteViewer: "Bronte Viewer",
};

export const pluginList = {
  "Bronte Viewer eText Plugin": courseTypes.bronteViewer,
  "Pearson eText course plugin": courseTypes.ePub,
};

export const checkReportOutputTypes = {
  CHANNEL_PARTNER: 'EPUB_CHANNEL_PARTNER',
  P_PLUS_INDESIGN : 'P_PLUS_INDESIGN',
};